import { createContext, useContext } from 'react';
import type { usePdfiumEngine } from '@embedpdf/engines/react';

type PdfiumEngine = ReturnType<typeof usePdfiumEngine>['engine'];

export interface PdfEngineValue {
  engine: PdfiumEngine;
  isLoading: boolean;
  error: unknown;
  /** Starts building the engine. Safe to call repeatedly. */
  warmUp: () => void;
}

export const PdfEngineContext = createContext<PdfEngineValue>({
  engine: null,
  isLoading: false,
  error: null,
  warmUp: () => {},
});

export function usePdfEngine() {
  return useContext(PdfEngineContext);
}
